module.exports = __webpack_public_path__ + "img/cystostop_sr.f4662e35.png";